import * as React from 'react';
import s from './searchBox.scss';
import {withTranslation, WithTranslation} from 'react-i18next';
import {getPathWithSearch, isValueValid} from '../../utils/search';
import {
  getTagByPath,
  isWindowWidthInRange,
  screenResolution
} from '../../utils';
import {logger} from '../../utils/bi';
import {History} from 'history';

export interface SearchBoxProps {
  toggleSearchBox?: (...args: any[]) => any;
  toggleMenu: (...args: any[]) => any;
  mobile: boolean;
  updateSearch?: (...args: any[]) => any;
  loadArticles: (...args: any[]) => any;
  history: History;
  hasResults?: (...args: any[]) => any;
  sending?: (...args: any[]) => any;
  toggleMobileSearchForm?: (...args: any[]) => any;
  searchRequest?: boolean;
  gotResults?: boolean;
  openMobileSearchForm?: boolean;
  search?: string;
}

export interface SearchBoxState {
  value: any | string;
  previousValue: string;
  showNoResultMessage: boolean;
  openSearchBar?: boolean;
}

class SearchBox extends React.Component<SearchBoxProps & WithTranslation, SearchBoxState> {
  private searchInput: HTMLInputElement;
  static defaultProps = {
    sending: () => {},
    updateSearch: () => {},
    toggleMobileSearchForm: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.search || '',
      previousValue: '',
      showNoResultMessage: false,
      openSearchBar: false,
    };
  }

  completeSearchAction(data?) {
    const {history, toggleMenu, search} = this.props;
    const path = getPathWithSearch(history, this.state.value);
    history.push(path);
    logger({evid: 333, search_term: search});
    this.searchInput.blur();
    toggleMenu(false);
    this.setState({
      openSearchBar: false,
    });
  }

  submitForm(e?) {
    const {loadArticles, history, mobile, sending, search} = this.props;
    if (!isValueValid(this.state.value) || this.state.value === search) {
      return;
    }
    sending(true);
    this.props.updateSearch(this.state.value);

    loadArticles(
      getTagByPath(history.location.pathname),
      1,
      this.state.value,
      mobile
        ? data => this.mobileCompleteSearchAction(data)
        : data => this.completeSearchAction(data)
    );
  }

  toggleSearch(e?) {
    this.searchInput.focus();
    this.props.toggleMobileSearchForm(!this.props.openMobileSearchForm);
  }

  mobileCompleteSearchAction(data) {
    if (data.items.length !== 0) {
      this.completeSearchAction();
    }
  }

  onSubmitHandler(e) {
    e.preventDefault();
    if (this.props.mobile && !this.props.openMobileSearchForm) {
      this.toggleSearch(e);
    } else {
      this.submitForm(e);
    }
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      if (
        isWindowWidthInRange(screenResolution.medium) &&
        this.state.openSearchBar
      ) {
        if (this.props.openMobileSearchForm) {
          this.props.toggleMenu(true);
        }
      }
    });
    document.addEventListener('focusout', e => {
      if (this.props.mobile) {
        this.onSubmitHandler(e);
      }
    });
  }

  handleVisibilityToggleClick = () => {
    this.setState(state => ({
      openSearchBar: !state.openSearchBar,
    }));
  }

  render() {
    const {
      t,
      mobile,
      searchRequest,
      gotResults,
      toggleSearchBox,
      openMobileSearchForm
    } = this.props;
    const mobileClass = mobile ? s.mobile : '';
    const toggleState = openMobileSearchForm || this.state.value !== '';
    return (
      <span className={s.formContainer}>
        <form
          data-hooks="search-form"
          data-toggle={toggleState}
          onSubmit={e => this.onSubmitHandler(e)}
          className={`${s.form} ${mobileClass}`}
        >
          <input
            onChange={this.handleVisibilityToggleClick}
            type="checkbox"
            id={s.displayCheckbox}
            className={s.displayCheckbox}
            checked={this.state.openSearchBar}
            data-hooks="visibility-checkbox"
          />
          <label htmlFor="search" className={s.box}>
            <input
              className={s.input}
              data-hooks="search-input"
              type="search"
              id="search"
              placeholder={t('search_pleaceholder')}
              onChange={e => {
                this.setState({value: e.target.value});
              }}
              value={this.state.value}
              ref={input => (this.searchInput = input)}
              onFocus={e => {
                e.preventDefault();
                if (toggleSearchBox) {
                  toggleSearchBox();
                }
              }}
            />
          </label>

          <label htmlFor={s.displayCheckbox} className={s.focusLabel} data-hooks="search-visibility-toggle">
          </label>

          <label htmlFor="submit" className={s.submitLabel}>
            <input
              type="submit"
              className={`${s.input} ${s.submit}`}
              id="submit"
              value=""
              onSubmit={e => this.onSubmitHandler(e)}
              data-hooks="search-submit-button"
              title={t('search.submit.button')}
            />
          </label>
        </form>
        <label
          data-hooks="search-mobile-message-error"
          className={`${s.noResultsMessage} ${
            mobile && !gotResults && !searchRequest ? s.show : ''
          }`}
        >
          {t('no.search.results.message')}
        </label>
      </span>
    );
  }
}
export default withTranslation()(SearchBox);
